import React, { PureComponent } from 'react'
import './styles.scss'
import PropTypes from 'prop-types'
import ToolTip from '../../ToolTip'

class Checkbox extends PureComponent {
  render () {
    let classNames = 'checkbox checkbox-' + this.props.kind
    if (this.props.classNames) {
      classNames += ' ' + this.props.classNames
    }
    if (this.props.labelHoverColor) {
      classNames += ' checkbox-label-hover-color'
    }
    const styles = {
      ...(this.props.labelHoverColor && { '--checkbox-label-hover-color': this.props.labelHoverColor }),
      ...(this.props.size && { '--checkbox-size': `${this.props.size}px` })
    }
    let label
    if (this.props.label !== undefined) {
      classNames += ' checkbox-with-label'
      label = <label className={this.props.tooltip ? 'ToolTip-Handle' : ''}>
        {this.props.label}
        {
          this.props.tooltip && <ToolTip
            hoverDelay={this.props.tooltipHoverDelay}
            showPointer={false}
            position="right"
            minWidth={this.props.tooltipMinWidth}
          >
            {this.props.tooltip}
          </ToolTip>
        }
      </label>
    }
    return (
      <div className={classNames} style={styles}>
        {this.props.prependLabel && label}
        <input type="checkbox" checked={this.props.value} onChange={this.props.onChange} disabled={this.props.disabled}/>
        {!this.props.prependLabel && label}
      </div>
    )
  }
}

Checkbox.defaultProps = {
  classNames: 'checkbox-default',
  prependLabel: false,
  kind: 'primary',
  size: 20,
  disabled: false,
}

Checkbox.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.bool.isRequired,
  label: PropTypes.string,
  labelHoverColor: PropTypes.string,
  classNames: PropTypes.string,
  prependLabel: PropTypes.bool,
  tooltip: PropTypes.string,
  tooltipHoverDelay: PropTypes.number,
  tooltipMinWidth: PropTypes.number,
  kind: PropTypes.oneOf(['primary', 'secondary', 'tertiary']),
  size: PropTypes.number,
  disabled: PropTypes.bool,
}

export default Checkbox
